import { useState } from 'react';
import type { UserRole } from '@worksy360/shared';
import { DEMO_TENANT, useAuth } from '../lib/auth.js';
import { Button, Card, Field, Input, Select } from '../ui/index.js';

/**
 * DEV sign-in. Mints a dev token (API runs AUTH_MODE=dev locally). Lets you pick a role to
 * demonstrate server-side RBAC. In production this screen is replaced by Cognito Hosted UI / SRP.
 */
const ROLE_USERS: Record<string, { userId: string; name: string }> = {
  owner: { userId: 'usr_owner', name: 'Alex Owner' },
  dispatcher: { userId: 'usr_dispatch', name: 'Dana Dispatcher' },
  technician: { userId: 'usr_tech1', name: 'Terry Tech' },
  read_only: { userId: 'usr_ro', name: 'Riley Viewer' },
};

export function Login() {
  const { signIn } = useAuth();
  const [role, setRole] = useState<UserRole>('owner');

  const submit = () => {
    const u = ROLE_USERS[role]!;
    signIn({ tenantId: DEMO_TENANT, userId: u.userId, userName: u.name, roles: [role] });
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 'var(--sp-6)' }}>
      <Card className="card-pad" >
        <div style={{ width: 'min(360px, 90vw)', display: 'flex', flexDirection: 'column', gap: 'var(--sp-4)' }}>
          <div className="stack" style={{ alignItems: 'center', gap: 6 }}>
            <img src="/full_logo.png" alt="Worksy360" style={{ width: 'min(240px, 80%)', height: 'auto' }} />
            <span className="subtle" style={{ fontSize: 'var(--text-xs)' }}>Field service operations</span>
          </div>
          <p className="muted" style={{ fontSize: 'var(--text-sm)' }}>
            Development sign-in. Choose a role to see how permissions change what you can do — the
            API enforces them server-side.
          </p>
          <Field label="Sign in as">
            <Select value={role} onChange={(e) => setRole(e.target.value as UserRole)}>
              <option value="owner">Owner — full access</option>
              <option value="dispatcher">Dispatcher — ops & scheduling</option>
              <option value="technician">Technician — assigned work</option>
              <option value="read_only">Read only — view only</option>
            </Select>
          </Field>
          <Button size="lg" block onClick={submit}>Enter Worksy360 →</Button>
          <span className="subtle" style={{ fontSize: 'var(--text-xs)', textAlign: 'center' }}>Demo tenant · {DEMO_TENANT.slice(0, 12)}…</span>
        </div>
      </Card>
    </div>
  );
}
